/**
 * A helper function to validate a supplied string as a valid email address.
 * We also alow for empty string.
 *
 * @param suppliedEmail
 */
export const validateEmail = (suppliedEmail: string): boolean => {
  let isValid = false;
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(suppliedEmail)) {
    isValid = true;
  }

  return isValid;
};

/**
 * A helper function to validate a supplied string as a phone number.
 * We also alow for empty string.
 *
 * @param suppliedNumber
 */
export const validatePhoneNumber = (suppliedNumber: string): boolean => {
  let isValid = false;

  // Check that phone number starts with + and six or more digits
  if (/^(\+)(\d{6,})$/.test(suppliedNumber) || suppliedNumber === '') {
    isValid = true;
  }

  return isValid;
};

/**
 * A helper function to validate a supplied string as a valid Finnish IBAN.
 *
 * @param suppliedIban
 */
export const validateIban = (suppliedIban: string): boolean => {
  let isValid = false;

  // Check that IBAN starts with FI and has 16 digits
  if (/^(\F\I)(\d{16})$/.test(suppliedIban)) {
    isValid = true;
  }

  return isValid;
};

/**
 * A helper function to validate that a supplied string does not have any numbers in it.
 *
 * @param suppliedString
 */
export const validateStringWithoutNumbers = (suppliedString: string): boolean => {
  let isValid = false;

  // Check that string does not have numbers
  if (/^([^0-9]*)$/.test(suppliedString)) {
    isValid = true;
  }

  return isValid;
};

/**
 * A helper function to validate that a supplied string only has 5 numbers in it.
 *
 * @param suppliedString
 */
export const validateZipCode = (suppliedString: string): boolean => {
  let isValid = false;

  // Check that string has only 5 numbers
  if (/^([0-9]{5})$/.test(suppliedString)) {
    isValid = true;
  }

  return isValid;
};

/**
 * A helper function to validate that a supplied string has only numbers, letters, periods, hyphens and slashes.
 *
 * @param suppliedString
 */
export const validateAddressString = (suppliedString: string): boolean => {
  let isValid = false;

  // Check that string has only numbers, letters, periods, hyphens and slashes
  if (/^[a-zA-Z0-9./-]*$/.test(suppliedString)) {
    isValid = true;
  }

  return isValid;
};
